'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddItemsButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/AddItemsButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  handleClick: _react2.default.PropTypes.func
};

var AddItemsButton = exports.AddItemsButton = function (_BcReactComponent) {
  _inherits(AddItemsButton, _BcReactComponent);

  function AddItemsButton() {
    _classCallCheck(this, AddItemsButton);

    return _possibleConstructorReturn(this, (AddItemsButton.__proto__ || Object.getPrototypeOf(AddItemsButton)).apply(this, arguments));
  }

  _createClass(AddItemsButton, [{
    key: 'render',
    value: function render() {
      var handleClick = this.props.handleClick;

      return _react2.default.createElement(
        _baseButtons.PrimaryGhostButton,
        {
          className: 'cp-user-list-add-items-button',
          handleClick: handleClick,
          'data-test-id': 'add-items-button' },
        _react2.default.createElement(_baseIcons.Plus, null),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'span',
            { className: 'hidden-sm hidden-md hidden-lg' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_add' })
          ),
          _react2.default.createElement(
            'span',
            { className: 'hidden-xs' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_add_to_list' })
          )
        )
      );
    }
  }]);

  return AddItemsButton;
}(_baseBcReactComponent2.default);

AddItemsButton.propTypes = propTypes;

exports.default = AddItemsButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-items-button/components/AddItemsButton.component.js
// module id = 1270
// module chunks = 0